module.exports = __webpack_public_path__ + "img/twitter.light.4c8a33fa.svg";